import Dexie from 'dexie';
import { applyEncryptionMiddleware } from 'dexie-encrypted';
import moment from 'moment-timezone';
// eslint-disable-next-line import/no-cycle
// eslint-disable-next-line import/no-cycle
import { addCases, addComplianceAppData, updateCase } from './utils';
// eslint-disable-next-line import/no-cycle
import { addEditProduct } from '../helpers/find-product';
import { INDEXED_DB_ENC_KEY } from '../common/config';
// eslint-disable-next-line import/no-cycle,import/named
// import { getUser, SERVER_TIMEZONE } from '../common/globals';
import Bugsnag from '../helpers/bugsnag';
// eslint-disable-next-line import/no-cycle
import { addEditDers } from '../helpers/find-ders';

let db = null;
const TABLES = {
  Hospitals: '++id, SalesRepHospitalID, OfficeName, TeamName, TeamNo, CustomerName, CustomerNo, '
    + 'CustomerAbb, DateModified, Deleted, NeedPrice, DateDeleted, VHN_PPC, VHN_Other, VRAS_PPC, VRAS_Other, UseCustCaseID, LineItem',
  Surgeons: '++id, OfficeName, TeamName, SurgeonName, SalesRepSurgeonID, DateModified,Deleted, DateDeleted, surgeon_hospitals',
  Components: '++id, CaseType, Components, ComponentID, DateModified, Deleted, DateDeleted',
  SetMaster: '++id, setType, SetMaterSetNameID, OfficeName, SetName, CaseType, DeviceType, ProcedureType, '
    + 'Component, ComponentID, SubOfficeName, DateModified, Deleted, DateDeleted',
  RepReports: '++id, name, updatedAt, fileSize, group',
  Documents: '++id, name, updatedAt, fileSize, group',
  TypeOptions: '++id, OptionType, OptionName, OptionAbb, OptionNo, DateModified, Deleted, TypeOptionsID',
  ProductMaster: '++id, ProductNo, ProductDescription, GS1Barcode, DateModified, Deleted, ProductMasterID',
  Territories: '++id, abb, connectionStringApi, httpUrlApiNew, id, name, server',
  Office: '++id, abb, connectionStringApi, httpUrlApiNew, id, name, server',
  Team: '++id, id, name, teanLead, timezone, dgrsReuired, officeId, territoriesId',
  Cases: '++id, ACMAIVersion, ACMActualParts, ACMCaseFlags, ACMCaseID, ACMChange, ACMCx, ACMCxEmail'
    + 'ACMIssue, ACMOrder, ACMPartsSent, ACMPlannedParts, ACMRepLock, ACMSelectedParts, Age, AppSetQty, CaseDate, CaseNo, CaseScheduleID, CaseStatus,'
    + 'CaseTime, CaseType, ChangeRep, ChangedFields, Comments, CoverRep, CreateRep, CustomerName, CustomerNo, DERRequired, DGR,'
    + 'DGRBG, DGRSignature, DGRUpload, DGRViewed, DateDeleted, DateModified, Deleted, Gender, Height, HeightUnits, HeightValue, MRN, MultiProdRep, NoProducts,'
    + 'OfficeName, PatientID, ProcedureType, ProdNotesViewed, ProductNotes,'
    + 'ProductSubmitted, RepCaseNo, RepNotes, RepPONumber, SalesRepName, SalesRepNo, SetQty, Side, SubOfficeName, SubmitDate, Submitted,'
    + 'SurgeonName, SurgeonNo, SurgeonNotes, Synced, ViewShipTo, Weight, WeightUnits, WeightValue, case_dgrs, case_products, case_sets, case_sets_rbo, case_sets_ec, case_sets_removedcx, all_case_sets, case_xrays, totalBilling, Sync, VelysUsed, case_ders, NeedPrice, ACMCaseID2, CustCaseID, PriceSheet',
  ECKits: '++id, setType, ECKitID, CaseType, DeviceType, ECSetName, SetName, ECSetDescription, DateModified, Deleted, DateDeleted',
  TeamReps: '++id, OfficeName, SalesRepName, SalesRepNo, TeamName, Phone, Email, TeamLead, SalesRepID, SubOfficeName',
  SetMasterGroup: '++id, ID, OfficeName, SetGroup, CaseType, SetNames, SetCnt',
  Preferences: '++id, CaseType, Comments, Component, DeviceType, OfficeName, PreferenceID, PreferenceName, ProcedureType, RepNotes, SetName, TeamName',
  MissingDgrs: '++id,OfficeName,RepCaseNo,CaseNo,CaseDate,CaseTime,CustomerNo,CustomerName,SalesRepNo,SalesRepName,'
    + 'SurgeonName,PatientID,ProcedureType,CaseType,Side,CaseStatus,Comments,SubmitDate,SetQty,Synced,ChangeRep,CreateRep,'
    + 'ChangedFields,CaseScheduleID,Submitted,SubOfficeName,CoverRep,DGR,AppSetQty,DateModified,Deleted,DateDeleted,RepNotes,'
    + 'ProductSubmitted,ProductNotes,ProdNotesViewed,DGRSignature,DGRUpload,MRN,Gender,Age,DGRBG,MultiProdRep,ViewShipTo,RepPONumber,'
    + 'DGRViewed,NoProducts,SurgeonNo,SurgeonNotes,ACMCaseID,ACMPlannedParts,ACMActualParts,ACMPartsSent,ACMOrder,ACMChange,ACMIssue,'
    + 'Height,HeightUnits,HeightValue,Weight,WeightUnits,WeightValue,ACMCaseFlags,ACMSelectedParts,ACMCxEmail,ID,Amount,AmountDate,Capitated,ACMCaseID2,CustCaseID,'
    + 'PONumber,PODate,POIssue,Billed,BilledDate,'
    + 'case_sets, case_sets_rbo, case_sets_ec, case_sets_removedcx, all_case_sets, case_products, case_dgrs, case_xrays, VelysUsed',
  MissingPos: '++id,OfficeName,RepCaseNo,CaseNo,CaseDate,CaseTime,CustomerNo,CustomerName,SalesRepNo,SalesRepName,'
    + 'SurgeonName,PatientID,ProcedureType,CaseType,Side,CaseStatus,Comments,SubmitDate,SetQty,Synced,ChangeRep,CreateRep,'
    + 'ChangedFields,CaseScheduleID,Submitted,SubOfficeName,CoverRep,DGR,AppSetQty,DateModified,Deleted,DateDeleted,RepNotes,'
    + 'ProductSubmitted,ProductNotes,ProdNotesViewed,DGRSignature,DGRUpload,MRN,Gender,Age,DGRBG,MultiProdRep,ViewShipTo,RepPONumber,'
    + 'DGRViewed,NoProducts,SurgeonNo,SurgeonNotes,ACMCaseID,ACMPlannedParts,ACMActualParts,ACMPartsSent,ACMOrder,ACMChange,ACMIssue,'
    + 'Height,HeightUnits,HeightValue,Weight,WeightUnits,WeightValue,ACMCaseFlags,ACMSelectedParts,ACMCxEmail,ID,Amount,AmountDate,Capitated,ACMCaseID2,CustCaseID,'
    + 'PONumber,PODate,POIssue,Billed,BilledDate,'
    + 'case_sets, case_sets_rbo, case_sets_ec, case_sets_removedcx, all_case_sets, case_products, case_dgrs, case_xrays, VelysUsed',
  NotBilled: '++id,OfficeName,RepCaseNo,CaseNo,CaseDate,CaseTime,CustomerNo,CustomerName,SalesRepNo,SalesRepName,'
    + 'SurgeonName,PatientID,ProcedureType,CaseType,Side,CaseStatus,Comments,SubmitDate,SetQty,Synced,ChangeRep,CreateRep,'
    + 'ChangedFields,CaseScheduleID,Submitted,SubOfficeName,CoverRep,DGR,AppSetQty,DateModified,Deleted,DateDeleted,RepNotes,'
    + 'ProductSubmitted,ProductNotes,ProdNotesViewed,DGRSignature,DGRUpload,MRN,Gender,Age,DGRBG,MultiProdRep,ViewShipTo,RepPONumber,'
    + 'DGRViewed,NoProducts,SurgeonNo,SurgeonNotes,ACMCaseID,ACMPlannedParts,ACMActualParts,ACMPartsSent,ACMOrder,ACMChange,ACMIssue,'
    + 'Height,HeightUnits,HeightValue,Weight,WeightUnits,WeightValue,ACMCaseFlags,ACMSelectedParts,ACMCxEmail,ID,Amount,AmountDate,Capitated,ACMCaseID2,CustCaseID,'
    + 'PONumber,PODate,POIssue,Billed,BilledDate,'
    + 'case_sets, case_sets_rbo, case_sets_ec, case_sets_removedcx, all_case_sets, case_products, case_dgrs, case_xrays, VelysUsed',
  Billed: '++id,OfficeName,RepCaseNo,CaseNo,CaseDate,CaseTime,CustomerNo,CustomerName,SalesRepNo,SalesRepName,'
    + 'SurgeonName,PatientID,ProcedureType,CaseType,Side,CaseStatus,Comments,SubmitDate,SetQty,Synced,ChangeRep,CreateRep,'
    + 'ChangedFields,CaseScheduleID,Submitted,SubOfficeName,CoverRep,DGR,AppSetQty,DateModified,Deleted,DateDeleted,RepNotes,'
    + 'ProductSubmitted,ProductNotes,ProdNotesViewed,DGRSignature,DGRUpload,MRN,Gender,Age,DGRBG,MultiProdRep,ViewShipTo,RepPONumber,'
    + 'DGRViewed,NoProducts,SurgeonNo,SurgeonNotes,ACMCaseID,ACMPlannedParts,ACMActualParts,ACMPartsSent,ACMOrder,ACMChange,ACMIssue,'
    + 'Height,HeightUnits,HeightValue,Weight,WeightUnits,WeightValue,ACMCaseFlags,ACMSelectedParts,ACMCxEmail,ID,Amount,AmountDate,Capitated,ACMCaseID2,CustCaseID,'
    + 'PONumber,PODate,POIssue,Billed,BilledDate,'
    + 'case_sets, case_sets_rbo, case_sets_ec, case_sets_removedcx, all_case_sets, case_products, case_dgrs, case_xrays, VelysUsed',
  Inventory: '++id, ID, OfficeName, TeamName, AccountName, AccountAbb, AccountNo, ProductNo, '
    + 'LotNo, ProductDescription, Qty, ExpireDate, UpdateDate, InventoryType',
  InventoryScans: '++inventoryId, ID, OfficeName, TeamName, AccountName, AccountAbb, AccountNo, SessionID, SessionName,'
    + 'ProductBarcode, LotBarcode, ProductNo, ProductDescription, Qty, Submitted, LotNo, ExpireDate, ScanDate, ScanRep,'
    + 'SalesRepNo, DeviceID, BarcodeType, ProductEnterType, LotEnterType, ExpDateEnterType, ProductValid, SessionDate',
  ComplianceApp: '++id, CaseScheduleID, OfficeName, RepCaseNo, UserName, ComplianceType, UserResponse, ResponseDate, Sync',
  Teams: '++id, CasePrefix, DERContact, DERContactPhone, DEREmail, DERTerritory, DGRRequired, OfficeName, SalesRepTeamID, SubOfficeName,'
    + 'TeamAbb, TeamName, TeamNo, TimeZone',
  DERs: '++id, OfficeName, DERNo, COMNo, RepCaseNo, CaseNo, DEREmail, TeamName, CreateDate, SubmitDate, DERContact, DERContactPhone, DERRep,'
    + 'DERRepPhone, DERTerritory, ResponseLetter, ResponseRecipient, SurgeonName, CustomerName, CustomerNo, CreditInvoiceNo, CreditAccountNo,'
    + 'RepPresent, DateAware, DateImplanted, PrimaryCustomerSame, PrimaryCustomer, DateExplanted, PatientName, PatientAge, PatientDOB, PatientGender,'
    + 'PatientHeight, PatientHeightUnits, PatientWeight, PatientWeightUnits, PatientStudy, PatientClinicalID, PatientActivity, EventInfo, XraysAvailable,'
    + 'XraysReason, Loosening, LooseningComponents, LooseningInterface, CementMFR, ProductDeficiency, BrokenRemoved, SurgeryExtend, SurgeryExtendTime,'
    + 'ProductCode, ProductLot, ProductSide, ProductUsed, ProductedReturned, ProductQty, InvestigationRequestor, InvestigationDate, InvestigationResponder,'
    + 'InvestigationResponderTitle, Xray, XrayReason, Patient, PatientReason, Blood, BloodReason, Histology, HistologyReason, MRI, MRIReason,'
    + 'Ultrasound, UltrasoundReason, Clinical, ClinicalReason, Primary, PrimaryReason, Revision, RevisionReason, Submited, Sync, products',
  SurgeonNotes: '++id, SurgeonName, notes'
};

const hospitalUpdateNeedPrice = (dbParam) => {
  dbParam.Hospitals.toCollection().modify((item) => {
    if (item.NeedPrice === undefined) {
      item.NeedPrice = '0';
    }
    dbParam.Hospitals.update(item.id, item).then(() => { });
  });
};

const addDERRequiredToCases = (dbParam) => {
  dbParam.Cases.toCollection().modify((item) => {
    if (item.DERRequired === undefined) {
      item.DERRequired = null;
    }
    dbParam.Cases.update(item.id, item).then(() => { });
  });
};

const hospitalUpdate = (dbParam) => {
  dbParam.Hospitals.toCollection().modify((item) => {
    if (item.VHN_PPC === undefined) {
      item.VHN_PPC = '0';
    }
    dbParam.Hospitals.update(item.id, item).then(() => { });
  });
};

const hospitalsModified = (dbParam) => {
  dbParam.Hospitals.toCollection().modify((item) => {
    if (item.VHN_Other === undefined || item.VRAS_PPC === undefined || item.VRAS_Other) {
      // item.VHN_Other = '0';
      // item.VRAS_PPC = '0';
      // item.VRAS_Other = '0';
    }
    dbParam.Hospitals.update(item.id, item).then(() => { });
  });
};

const casesTblModified = (dbParam) => {
  dbParam.Cases.toCollection().modify((item) => {
    if (item.VelysUsed === undefined) {
      item.VelysUsed = null;
    }
    dbParam.Cases.update(item.id, item).then(() => { });
  });
};

const casesTblModifiedNeedPrice = (dbParam) => {
  dbParam.Cases.toCollection().modify((item) => {
    if (item.NeedPrice === undefined) {
      item.NeedPrice = '0';
    }
    dbParam.Cases.update(item.id, item).then(() => { });
  });
};

const missingDgrsTblModified = (dbParam) => {
  dbParam.MissingDgrs.toCollection().modify((item) => {
    if (item.VelysUsed === undefined) {
      item.VelysUsed = null;
    }
    dbParam.MissingDgrs.update(item.id, item).then(() => { });
  });
};

const missingPosTblModified = (dbParam) => {
  dbParam.MissingPos.toCollection().modify((item) => {
    if (item.VelysUsed === undefined) {
      item.VelysUsed = null;
    }
    dbParam.MissingPos.update(item.id, item).then(() => { });
  });
};

const notBilledTblModified = (dbParam) => {
  dbParam.NotBilled.toCollection().modify((item) => {
    if (item.VelysUsed === undefined) {
      item.VelysUsed = null;
    }
    dbParam.NotBilled.update(item.id, item).then(() => { });
  });
};

const billedTblModified = (dbParam) => {
  dbParam.Billed.toCollection().modify((item) => {
    if (item.VelysUsed === undefined) {
      item.VelysUsed = null;
    }
    dbParam.Billed.update(item.id, item).then(() => { });
  });
};

const casesTblModifiedCaseDers = (dbParam) => {
  dbParam.Cases.toCollection().modify((item) => {
    if (item.case_ders === undefined) {
      item.case_ders = null;
    }
    dbParam.Cases.update(item.id, item).then(() => { });
  });
};

const hospitalUpdateUseCustCaseID = (dbParam) => {
  dbParam.Hospitals.toCollection().modify((item) => {
    if (item.UseCustCaseID === undefined) {
      item.UseCustCaseID = '0';
    }
    dbParam.Hospitals.update(item.id, item).then(() => { });
  });
};

export const productDb = () => new Promise((resolve) => {
  try {
    // create database
    db = new Dexie('optimizeDb');

    applyEncryptionMiddleware(db, new Uint8Array(INDEXED_DB_ENC_KEY.split(',')), {
      ...TABLES
    });

    db.version(2).stores(TABLES);
    db.version(3).stores({ ComplianceApp: '++id, CaseScheduleID, OfficeName, RepCaseNo, UserName, ComplianceType, UserResponse, ResponseDate, Sync' });
    db.version(4).stores({
      Teams: '++id, CasePrefix, DERContact, DERContactPhone, DEREmail, DERTerritory, DGRRequired, OfficeName, SalesRepTeamID, SubOfficeName,'
        + 'TeamAbb, TeamName, TeamNo, TimeZone',
      DERs: '++id, OfficeName, DERNo, COMNo, RepCaseNo, CaseNo, DEREmail, TeamName, CreateDate, SubmitDate, DERContact, DERContactPhone, DERRep,'
        + 'DERRepPhone, DERTerritory, ResponseLetter, ResponseRecipient, SurgeonName, CustomerName, CustomerNo, CreditInvoiceNo, CreditAccountNo,'
        + 'RepPresent, DateAware, DateImplanted, PrimaryCustomerSame, PrimaryCustomer, DateExplanted, PatientName, PatientAge, PatientDOB, PatientGender,'
        + 'PatientHeight, PatientHeightUnits, PatientWeight, PatientWeightUnits, PatientStudy, PatientClinicalID, PatientActivity, EventInfo, XraysAvailable,'
        + 'XraysReason, Loosening, LooseningComponents, LooseningInterface, CementMFR, ProductDeficiency, BrokenRemoved, SurgeryExtend, SurgeryExtendTime,'
        + 'ProductCode, ProductLot, ProductSide, ProductUsed, ProductedReturned, ProductQty, InvestigationRequestor, InvestigationDate, InvestigationResponder,'
        + 'InvestigationResponderTitle, Xray, XrayReason, Patient, PatientReason, Blood, BloodReason, Histology, HistologyReason, MRI, MRIReason,'
        + 'Ultrasound, UltrasoundReason, Clinical, ClinicalReason, Primary, PrimaryReason, Revision, RevisionReason, Submited, Sync, products'
    });
    db.version(5).stores({
      AltCaseTypes: 'ID, CaseType, CaseCategory, AltCaseType, ProcedureType',
    });
    db.version(6);
    db.version(7);
    db.version(8);
    // Open the database

    db.open().catch((e) => {
      resolve(false);
      console.error(`Open failed: ${e}`);
    }).then(() => {
      // Modified Hospitals, Cases, MissingDgrs, MissingPos, NotBilled, and Billed tables
      hospitalUpdate(db);
      casesTblModified(db);
      hospitalsModified(db);
      missingDgrsTblModified(db);
      missingPosTblModified(db);
      notBilledTblModified(db);
      billedTblModified(db);
      casesTblModifiedCaseDers(db);
      casesTblModifiedNeedPrice(db);
      addDERRequiredToCases(db);
      hospitalUpdateNeedPrice(db);
      hospitalUpdateUseCustCaseID(db);
    });
    resolve(true);
  } catch (e) {
    resolve(false);
    Bugsnag.notify(e);
  }
});

export const syncCases = async () => {
  try {
    // GET CASES
    const caseRes = await db.Cases.toArray();
    if (caseRes.length > 0) {
      let hasOfflineCasesToDelete = false;
      await Promise.all(caseRes.map(async (item) => {
        if (item.CaseScheduleID === null) {
          const caseData = {
            CaseDate: item.CaseDate,
            CaseTime: item.CaseTime,
            CustomerNo: item.CustomerNo,
            CustomerName: item.CustomerName,
            SurgeonName: item.SurgeonName,
            PatientID: item.PatientID,
            ProcedureType: item.ProcedureType,
            AltCaseType: item.AltCaseType,
            CaseType: item.CaseType,
            Side: item.Side,
            Comments: item.Comments,
            RepNotes: item.RepCaseNo,
            ProductNotes: item.ProductNotes,
            ProductSubmitted: item.ProductSubmitted,
            RepPONumber: item.RepPONumber,
            Submitted: item.Submitted,
            CoverRep: item.CoverRep,
            ChangeRep: item.ChangeRep,
            DGRUpload: item.DGRUpload,
            MRN: item.MRN,
            Gender: item.Gender,
            Age: item.Age,
            Height: item.Height,
            HeightUnits: item.HeightUnits,
            HeightValue: item.HeightValue,
            Weight: item.Weight,
            WeightUnits: item.WeightUnits,
            WeightValue: item.WeightValue,
            VelysUsed: item.VelysUsed,
            NeedPrice: item.NeedPrice,
            ACMCaseID2: item.ACMCaseID2,
            CustCaseID: item.CustCaseID,
          };
          const addRes = await addCases(caseData);
          if (addRes.status) {
            await addEditProduct(addRes.data[0], item.case_products);
            hasOfflineCasesToDelete = true;
          }
        } else if (item.Sync === 1) {
          const updateCaseData = {
            CaseDate: item.CaseDate,
            CaseTime: item.CaseTime,
            CaseScheduleID: item.CaseScheduleID,
            CustomerNo: item.CustomerNo,
            CustomerName: item.CustomerName,
            SurgeonName: item.SurgeonName,
            PatientID: item.PatientID,
            DERRequired: item.DERRequired,
            ProcedureType: item.ProcedureType,
            CaseType: item.CaseType,
            AltCaseType: item.AltCaseType,
            Side: item.Side,
            Comments: item.Comments,
            RepNotes: item.RepCaseNo,
            ProductNotes: item.ProductNotes,
            ProductSubmitted: item.ProductSubmitted,
            RepPONumber: item.RepPONumber,
            Submitted: item.Submitted,
            CoverRep: item.CoverRep,
            ChangeRep: item.ChangeRep,
            DGRUpload: item.DGRUpload,
            MRN: item.MRN,
            Gender: item.Gender,
            Age: item.Age,
            ACMPlannedParts: item.ACMPlannedParts,
            ACMSelectedParts: item.ACMSelectedParts,
            Height: item.Height,
            HeightUnits: item.HeightUnits,
            HeightValue: item.HeightValue,
            Weight: item.Weight,
            WeightUnits: item.WeightUnits,
            WeightValue: item.WeightValue,
            VelysUsed: item.VelysUsed,
            NeedPrice: item.NeedPrice,
            ACMCaseID2: item.ACMCaseID2,
            CustCaseID: item.CustCaseID,
          };

          updateCaseData.selectedSets = item.case_sets.map(({
            CasePlanId: CasePlanID,
            ...rest
          }) => ({
            CasePlanID,
            ...rest
          }));
          const updatedRes = await updateCase(updateCaseData);
          if (updatedRes.status) {
            item.case_products = await addEditProduct(updatedRes.data[0],
              item.case_products);
            db.Cases.update(item.id, item);
            await addEditDers(item.case_ders);
            hasOfflineCasesToDelete = true;
          }
        }
      }));
      if (hasOfflineCasesToDelete) await deleteOfflineSyncCases();
    }

    const ComplianceAppRes = await db.ComplianceApp.toArray();
    if (ComplianceAppRes.length > 0) {
      // eslint-disable-next-line no-async-promise-executor
      const casePromiseAll = ComplianceAppRes.map(async (item) => new Promise(async (resolve) => {
        if (item.Sync === 1) {
          const complianceData = {
            CaseScheduleID: item.CaseScheduleID,
            ComplianceType: item.ComplianceType,
            UserResponse: item.UserResponse
          };
          const comAppRes = await addComplianceAppData(complianceData);
          if (comAppRes.message === 'VHN Compliance added successfully') {
            db.ComplianceApp.clear();
          }
        }
        resolve(true);
      }));
      await Promise.all(casePromiseAll);
    }
    return db;
  } catch (e) {
    Bugsnag.notify(e);
  }
};

export const setData = async (data) => {
  try {
    let oldTeamName = '';
    let newTeamName = '';

    // ADD COMPONENTS
    if (data.Components.length > 0) {
      try {
        const componentsRes = await db.Components.toArray();
        if (data.Components.length > componentsRes.length) {
          db.Components.clear();
          db.Components.bulkAdd(data.Components);
        }
      } catch (err) { }
    }

    // ADD REP REPORTS
    if (data.RepReports.length > 0) {
      try {
        data.RepReports.map((value) => {
          newTeamName = value.TeamName;
        });
        const repReportsRes = await db.RepReports.toArray();
        repReportsRes.map((item) => {
          oldTeamName = item.TeamName;
        });
        if (oldTeamName === newTeamName) {
          if (data.RepReports.length > repReportsRes.length) {
            db.RepReports.clear();
            db.RepReports.bulkAdd(data.RepReports);
          }
        } else {
          db.RepReports.clear();
          db.RepReports.bulkAdd(data.RepReports);
        }
      } catch (err) { }
    } else if (data.RepReports.length === 0) {
      db.RepReports.clear();
    }

    // ADD DOCUMENT
    if (data.Documents.length > 0) {
      try {
        db.Documents.clear();
        db.Documents.bulkAdd(data.Documents);
      } catch (err) { }
    } else if (data.Documents.length === 0) {
      db.Documents.clear();
    }

    // ADD SURGEONS
    if (data.Surgeons.length > 0) {
      try {
        // data.Surgeons.map((value) => {
        //   newTeamName = value.TeamName;
        // });
        // const surgeonsRes = await db.Surgeons.toArray();
        // surgeonsRes.map((item) => {
        //   oldTeamName = item.TeamName;
        // });
        // if (oldTeamName === newTeamName) {
        //   db.Surgeons.clear();
        //   db.Surgeons.bulkAdd(data.Surgeons);
        // } else {
        //   db.Surgeons.clear();
        //   db.Surgeons.bulkAdd(data.Surgeons);
        // }
        db.Surgeons.clear();
        db.Surgeons.bulkAdd(data.Surgeons);
      } catch (err) { }
    } else {
      db.Surgeons.clear();
    }

    // ADD HOSPITALS
    if (data.Hospitals.length > 0) {
      try {
        // data.Hospitals.map((value) => {
        //   newTeamName = value.TeamName;
        // });
        //
        // const hospitalsRes = await db.Hospitals.toArray();
        // hospitalsRes.map((item) => {
        //   oldTeamName = item.TeamName;
        // });
        // if (oldTeamName === newTeamName) {
        //   if (data.Hospitals.length > hospitalsRes.length) {
        //     db.Hospitals.clear();
        //     db.Hospitals.bulkAdd(data.Hospitals);
        //   }
        // } else {
        //   db.Hospitals.clear();
        //   db.Hospitals.bulkAdd(data.Hospitals);
        // }
        db.Hospitals.clear();
        db.Hospitals.bulkAdd(data.Hospitals);
      } catch (err) { }
    } else {
      db.Hospitals.clear();
    }

    // ADD PRODUCT MASTER
    if (data.ProductMaster.length > 0) {
      try {
        // const productMaster = await db.ProductMaster.toArray();
        // if (data.ProductMaster.length > productMaster.length) {
        //   db.ProductMaster.clear();
        //   db.ProductMaster.bulkAdd(data.ProductMaster);
        // }

        db.ProductMaster.clear();
        db.ProductMaster.bulkAdd(data.ProductMaster);
      } catch (err) { }
    }

    // ADD TYPE OPTIONS
    if (data.TypeOptions.length > 0) {
      try {
        const typeOption = await db.TypeOptions.toArray();
        if (data.TypeOptions.length > typeOption.length) {
          db.TypeOptions.clear();
          db.TypeOptions.bulkAdd(data.TypeOptions);
        }
      } catch (err) { }
    }

    // ADD SET MASTER
    if (data.SetMaster.length > 0) {
      try {
        db.SetMaster.clear();
        db.SetMaster.bulkAdd(data.SetMaster);
      } catch (err) { }
    }

    // ADD EXPRESS CARE SETS
    if (data.ECKits.length > 0) {
      try {
        const ecKitsRes = await db.ECKits.toArray();
        if (data.ECKits.length > ecKitsRes.length) {
          db.ECKits.clear();
          const ECKitsPromiseAll = data.ECKits.map((item) => new Promise((resolve) => {
            item.SetName = item.ECSetName;
            item.Quantity = 0;
            resolve(true);
          }));
          await Promise.all(ECKitsPromiseAll);
          db.ECKits.bulkAdd(data.ECKits);
        }
      } catch (err) { }
    }

    // ADD TEAM REPS
    if (data.TeamReps.length > 0) {
      try {
        data.TeamReps.map((value) => {
          newTeamName = value.TeamName;
        });
        const TeamRepsRes = await db.TeamReps.toArray();
        TeamRepsRes.map((item) => {
          oldTeamName = item.TeamName;
        });
        if (oldTeamName === newTeamName) {
          if (data.TeamReps.length > TeamRepsRes.length) {
            db.TeamReps.clear();
            db.TeamReps.bulkAdd(data.TeamReps);
          }
        } else {
          db.TeamReps.clear();
          db.TeamReps.bulkAdd(data.TeamReps);
        }
      } catch (err) { }
    } else {
      db.TeamReps.clear();
    }

    // ADD CASES
    if (data.Cases.length > 0) {
      try {
        // const user = await getUser();
        // const { selectedTeam: { timezone } } = user;
        db.Cases.clear();
        const CasesPromiseAll = data.Cases.map((item) => new Promise((resolve) => {
          // const dateTime = `${item.CaseDate} ${item.CaseTime}`;
          // const convertedDateTime = moment(moment.tz(
          //   dateTime, 'YYYY-MM-DD HH:mm', SERVER_TIMEZONE
          // )).tz(timezone).format('YYYY-MM-DD HH:mm');
          const date = moment(item.CaseDate).format('YYYY-MM-DD');
          const time = moment(item.CaseTime).format('HH:mm');
          item.CaseDate = date;
          item.CaseTime = time;
          item.Sync = 0;
          item.case_products.map((value) => {
            // value.ScanDate = moment(moment.tz(
            //   value.ScanDate, 'YYYY-MM-DD HH:mm:ss.SSS', SERVER_TIMEZONE
            // )).tz(timezone).format('YYYY-MM-DD HH:mm:ss.SSS');
            value.ScanDate = moment(value.ScanDate).format('YYYY-MM-DD HH:mm:ss.SSS');
          });

          const filtered = [];
          for (let i = 0; i < item.case_ders.length; i++) {
            let isHasNotEqual = true;
            for (let j = 0; j < filtered.length; j++) {
              if (filtered[j].DERNo === item.case_ders[i].DERNo) {
                isHasNotEqual = false;
              }
            }
            if (isHasNotEqual) {
              filtered.push(item.case_ders[i]);
            }
          }
          item.case_ders = filtered;
          resolve(true);
        }));
        await Promise.all(CasesPromiseAll);
        db.Cases.clear();
        db.Cases.bulkAdd(data.Cases);
      } catch (err) { }
    } else if (data.Cases.length === 0) {
      db.Cases.clear();
    }

    // ADD PREFERENCE
    if (data.Preferences.length > 0) {
      try {
        const casesRes = await db.Preferences.toArray();
        if (data.Preferences.length > casesRes.length) {
          db.Preferences.clear();
          db.Preferences.bulkAdd(data.Preferences);
        }
      } catch (err) { }
    }

    // ADD HOSPITALS
    if (data.Hospitals.length > 0) {
      try {
        const hospitalsRes = await db.Hospitals.toArray();
        if (data.Hospitals.length > hospitalsRes.length) {
          db.Hospitals.clear();
          db.Hospitals.bulkAdd(data.Hospitals);
        }
      } catch (err) { }
    }

    // ADD SETS GROUP
    if (data.SetMasterGroup.length > 0) {
      try {
        const hospitalsRes = await db.SetMasterGroup.toArray();
        if (data.SetMasterGroup.length > hospitalsRes.length) {
          db.SetMasterGroup.clear();
          db.SetMasterGroup.bulkAdd(data.SetMasterGroup);
        }
      } catch (err) { }
    }

    // ADD TEAMS
    if (data.Teams.length > 0) {
      db.Teams.clear();
      try {
        const teamsRes = await db.Teams.toArray();
        if (data.Teams.length > teamsRes.length) {
          db.Teams.clear();
          db.Teams.bulkAdd(data.Teams);
        }
      } catch (err) { }
    }

    // ADD AltCaseTypes
    if (data.AltCaseTypes.length > 0) {
      db.AltCaseTypes.clear();
      try {
        db.AltCaseTypes.bulkAdd(data.AltCaseTypes);
      } catch (error) {
        Bugsnag.notify(error);
      }
    }

    // ADD SURGEON NOTES
    if (data.SurgeonNotes.length > 0) {
      try {
        db.SurgeonNotes.clear();
        db.SurgeonNotes.bulkAdd(data.SurgeonNotes);
      } catch (err) { }
    }

    return db;
  } catch (e) {
    Bugsnag.notify(e);
  }
};

export const setCaseData = async (data) => {
  try {
    // ADD CASES
    if (data.Cases.length > 0) {
      try {
        // const user = await getUser();
        // const { selectedTeam: { timezone } } = user;
        db.Cases.clear();
        const CasesPromiseAll = data.Cases.map((item) => new Promise((resolve) => {
          // const dateTime = `${item.CaseDate} ${item.CaseTime}`;
          // const convertedDateTime = moment(moment.tz(
          //   dateTime, 'YYYY-MM-DD HH:mm', SERVER_TIMEZONE
          // )).tz(timezone).format('YYYY-MM-DD HH:mm');
          const date = moment(item.CaseDate).format('YYYY-MM-DD');
          const time = moment(item.CaseTime).format('HH:mm');
          item.CaseDate = date;
          item.CaseTime = time;
          item.Sync = 0;
          item.case_products.map((value) => {
            // value.ScanDate = moment(moment.tz(
            //   value.ScanDate, 'YYYY-MM-DD HH:mm:ss.SSS', SERVER_TIMEZONE
            // )).tz(timezone).format('YYYY-MM-DD HH:mm:ss.SSS');
            value.ScanDate = moment(value.ScanDate).format('YYYY-MM-DD HH:mm:ss.SSS');
          });

          const filtered = [];
          for (let i = 0; i < item.case_ders.length; i++) {
            let isHasNotEqual = true;
            for (let j = 0; j < filtered.length; j++) {
              if (filtered[j].DERNo === item.case_ders[i].DERNo) {
                isHasNotEqual = false;
              }
            }
            if (isHasNotEqual) {
              filtered.push(item.case_ders[i]);
            }
          }
          item.case_ders = filtered;
          resolve(true);
        }));
        await Promise.all(CasesPromiseAll);
        db.Cases.clear();
        db.Cases.bulkAdd(data.Cases);
      } catch (err) { }
    } else if (data.Cases.length === 0) {
      db.Cases.clear();
    }
    return db;
  } catch (e) {
  }
};

export const getCaseType = async () => await db.TypeOptions.where({ OptionType: 'CaseType' }).toArray();

export const getAltCaseTypes = async () => await db.AltCaseTypes.toArray();

export const getComponent = async () => await db.Components.toArray();

export const getSetsMasterGroup = async () => await db.SetMasterGroup.toArray();

export const getRepReports = async () => await db.RepReports.toArray();

export const getSurgeons = async () => await db.Surgeons.toArray();

export const getProcedureTypes = async () => await db.TypeOptions.where({ OptionType: 'ProcedureType' }).toArray();

export const getProduct = async (key, value) => {
  try {
    if (key === 'GS1Barcode') {
      try {
        const data = await db.ProductMaster.where({ GS1Barcode: value }).first();
        return data === undefined ? {} : data;
      } catch (err) {
        return {};
      }
    }

    if (key === 'ProductNo') {
      try {
        const data = await db.ProductMaster.where({ ProductNo: value }).first();
        return data === undefined ? {} : data;
      } catch (err) {
        return {};
      }
    }
  } catch (e) {
    Bugsnag.notify(e);
  }
};

export const getProductChargeType = async () => await db.TypeOptions.where({ OptionType: 'ChargeType' }).toArray();

export const getSetMaster = async () => await db.SetMaster.toArray();

export const getInventoryType = async () => await db.TypeOptions.where({ OptionType: 'InventoryType' }).toArray();

export const getECKits = async () => await db.ECKits.toArray();

export const getTeamReps = async () => await db.TeamReps.toArray();

export const getTeams = async () => await db.Teams.toArray();

export const getSideType = async () => await db.TypeOptions.where({ OptionType: 'SideType' }).toArray();

export const getGenderType = async () => await db.TypeOptions.where({ OptionType: 'GenderType' }).toArray();

export const getHeightUnitType = async () => await db.TypeOptions.where({ OptionType: 'HeightUnitType' }).toArray();

export const getWeightUnitType = async () => await db.TypeOptions.where({ OptionType: 'WeightUnitType' }).toArray();

export const getDeviceType = async () => await db.TypeOptions.where({ OptionType: 'DeviceType' }).toArray();

export const getCasesByDate = async (date) => await db.Cases.where({ CaseDate: date }).toArray();

export const getCasesByBetweenDate = async (startDate, endDate) => await db.Cases.where('CaseDate').between(startDate, endDate, true, true).toArray();

export const getCaseByCaseId = async (id) => await db.Cases.get(Number(id));

export const getManageCaseByCaseId = async (id) => {
  try {
    const results = await db.Cases.get(Number(id));
    return results === undefined ? {} : results;
  } catch (e) {
    Bugsnag.notify(e);
  }
};

export const getMassingPosCaseByCaseId = async (id) => {
  try {
    const results = await db.MissingPos.get(Number(id));
    return results === undefined ? {} : results;
  } catch (e) {
    Bugsnag.notify(e);
  }
};

export const getNotBilledCaseByCaseId = async (id) => {
  try {
    const results = await db.NotBilled.get(Number(id));
    return results === undefined ? {} : results;
  } catch (e) {
    Bugsnag.notify(e);
  }
};

export const getTableCaseByCaseId = async (id, tableName) => await db[tableName].get(Number(id));

export const getCaseByCaseScheduleID = async (id) => await db.Cases.get({ CaseScheduleID: id });

export const getCases = async () => await db.Cases.toArray();

export const getNotSyncdCases = async () => await db.Cases.where({ Sync: 1 }).toArray();

export const getHospitals = async () => await db.Hospitals.toArray();

export const getCustomerNoByName = async (name) => await db.Hospitals.where(
  { CustomerName: name }
).first();

export const getSetGroupByGroupName = async (groupName) => await db.SetMasterGroup.where(
  { SetGroup: groupName }
).toArray();

export const getHospitalByCustomerNo = async (customerNo) => await db.Hospitals.where(
  { CustomerNo: customerNo }
).first();

export const getECSetDesc = async (name) => await db.ECKits.where(
  { ECSetName: name }
).first();

export const deleteSyncedCases = async () => {
  await db.Cases.where({ Sync: 0 }).delete();
};

// Delete offline created cases after syncCases
export const deleteOfflineSyncCases = async () => {
  await db.Cases.where({ Sync: 1 }).delete();
};

export const deleteCaseByCaseId = async (id) => {
  try {
    db.Cases.delete(Number(id)).then((response) => {
      if (response) {
        console.log('Case deleted successfully.');
      } else {
        console.log('Something went wrong!');
      }
    });
  } catch (e) {
    Bugsnag.notify(e);
  }
};

export const deleteTableWiseCaseByCaseId = async (id, tableName) => {
  try {
    db[tableName].delete(Number(id)).then((response) => {
      if (response) {
        console.log('Case deleted successfully.');
      } else {
        console.log('Something went wrong!');
      }
    });
  } catch (e) {
    Bugsnag.notify(e);
  }
};

export const updateCaseByCaseId = async (id, data) => {
  try {
    const response = await db.Cases.update({ RepCaseNo: id }, data);
    if (response) {
      console.log('Case updated successfully.');
    } else {
      console.log('Case not update! Please try again!');
    }
    return response;
  } catch (e) {
    Bugsnag.notify(e);
  }
  return 0;
};

export const updateMissingDGRsByCaseId = async (id, data) => {
  try {
    return await db.MissingDgrs.update({ RepCaseNo: id }, data);
  } catch (e) {
    Bugsnag.notify(e);
  }
  return 0;
};

export const updateMissingPOsByCaseId = async (id, data) => {
  try {
    return await db.MissingPos.update({ RepCaseNo: id }, data);
  } catch (e) {
    Bugsnag.notify(e);
  }
  return 0;
};

export const updateNotBilledByCaseId = async (id, data) => {
  try {
    return await db.NotBilled.update({ RepCaseNo: id }, data);
  } catch (e) {
    Bugsnag.notify(e);
  }
  return 0;
};

export const updateBilledByCaseId = async (id, data) => {
  try {
    return await db.Billed.update({ RepCaseNo: id }, data);
  } catch (e) {
    Bugsnag.notify(e);
  }
  return 0;
};

export const updateTableWiseCaseByCaseId = (id, data, tableName) => {
  try {
    db[tableName].update({ RepCaseNo: id }, data).then((response) => {
      if (response) {
        console.log('Case updated successfully.');
      } else {
        console.log('Case not update! Please try again!');
      }
    });
  } catch (e) {
    Bugsnag.notify(e);
  }
};

// ADD NEW INSERTED CASE RESPONSE
export const insertCaseByCaseId = async (data) => {
  try {
    if (typeof data.CaseScheduleID !== 'undefined') {
      const resp = await db.Cases.where({ CaseScheduleID: data.CaseScheduleID }).first();
      if (typeof resp !== 'undefined' && typeof resp.CaseScheduleID !== 'undefined' && resp.CaseScheduleID !== '') {
        const response = await db.Cases.update({ CaseScheduleID: data.CaseScheduleID }, data);
        if (response) {
          console.log('Case updated successfully.');
        } else {
          console.log('Case not update! Please try again!');
        }
      } else {
        db.Cases.add(data).then((response) => {
          if (response) {
            console.log('Case inserted successfully.');
          } else {
            console.log('Case not insert! Please try again!');
          }
        });
      }
    } else {
      db.Cases.add(data).then((response) => {
        if (response) {
          console.log('Case inserted successfully.');
        } else {
          console.log('Case not insert! Please try again!');
        }
      });
    }
  } catch (e) {
    Bugsnag.notify(e);
  }
};

export const getAllPreferences = async () => await db.Preferences.toArray();

export const bulkManageCaseAdd = async (data) => {
  // const user = await getUser();
  // const { selectedTeam: { timezone } } = user;
  const CasesPromiseAll = data.map((item) => new Promise((resolve) => {
    // const dateTime = `${item.CaseDate} ${item.CaseTime}`;
    // const convertedDateTime = moment(moment.tz(
    //   dateTime, 'YYYY-MM-DD HH:mm', SERVER_TIMEZONE
    // )).tz(timezone).format('YYYY-MM-DD HH:mm');
    const date = moment(item.CaseDate).format('YYYY-MM-DD');
    const time = moment(item.CaseTime).format('HH:mm');
    item.CaseDate = date;
    item.CaseTime = time;
    item.Sync = 0;
    item.case_products.map((value) => {
      // value.ScanDate = moment(moment.tz(
      //   value.ScanDate, 'YYYY-MM-DD HH:mm:ss.SSS', SERVER_TIMEZONE
      // )).tz(timezone).format('YYYY-MM-DD HH:mm:ss.SSS');
      value.ScanDate = moment(value.ScanDate).format('YYYY-MM-DD HH:mm:ss.SSS');
    });
    const filtered = [];
    for (let i = 0; i < item.case_ders.length; i++) {
      let isHasNotEqual = true;
      for (let j = 0; j < filtered.length; j++) {
        if (filtered[j].DERNo === item.case_ders[i].DERNo) {
          isHasNotEqual = false;
        }
      }
      if (isHasNotEqual) {
        filtered.push(item.case_ders[i]);
      }
    }
    item.case_ders = filtered;
    resolve(true);
  }));
  await Promise.all(CasesPromiseAll);
  db.Cases.bulkAdd(data);
};

export const singleManageCaseAdd = async (data) => {
  // const user = await getUser();
  // const { selectedTeam: { timezone } } = user;
  // const caseToAdd = await formatCase(data, timezone);
  const caseToAdd = await formatCase(data);
  if (typeof data.CaseScheduleID !== 'undefined') {
    const resp = await db.Cases.where({ CaseScheduleID: data.CaseScheduleID }).first();
    if (typeof resp !== 'undefined' && resp !== null && typeof resp.CaseScheduleID !== 'undefined' && resp.CaseScheduleID !== '') {
      return resp.id;
    }
  }
  return await db.Cases.add(caseToAdd);
};

const formatCase = (data) => { // timezone
  const caseToAdd = { ...data };
  // const dateTime = `${caseToAdd.CaseDate} ${caseToAdd.CaseTime}`;
  // const convertedDateTime = moment(moment
  //   .tz(dateTime, 'YYYY-MM-DD HH:mm', SERVER_TIMEZONE))
  //   .tz(timezone).format('YYYY-MM-DD HH:mm');
  const date = moment(caseToAdd.CaseDate).format('YYYY-MM-DD');
  const time = moment(caseToAdd.CaseTime).format('HH:mm');
  caseToAdd.CaseDate = date;
  caseToAdd.CaseTime = time;
  caseToAdd.Sync = 0;
  caseToAdd.case_products.map((value) => {
    // value.ScanDate = moment(moment
    //   .tz(value.ScanDate, 'YYYY-MM-DD HH:mm:ss.SSS', SERVER_TIMEZONE))
    //   .tz(timezone).format('YYYY-MM-DD HH:mm:ss.SSS');
    value.ScanDate = moment(value.ScanDate).format('YYYY-MM-DD HH:mm:ss.SSS');
  });
  const filtered = [];
  for (let i = 0; i < caseToAdd.case_ders.length; i++) {
    let isHasNotEqual = true;
    for (let j = 0; j < filtered.length; j++) {
      if (filtered[j].DERNo === caseToAdd.case_ders[i].DERNo) {
        isHasNotEqual = false;
      }
    }
    if (isHasNotEqual) {
      filtered.push(caseToAdd.case_ders[i]);
    }
  }
  caseToAdd.case_ders = filtered;
  return caseToAdd;
};

export const filterCase = async (data, table) => {
  try {
    let query = db[table].orderBy('CaseType');
    if (data.hasOwnProperty('selectedStartDate')) {
      const date = moment(data.selectedStartDate[0], 'DD MMM YYYY').format('YYYY-MM-DD');
      query = query.filter(({ CaseDate }) => (CaseDate >= date));
    }

    if (data.hasOwnProperty('selectedEndDate')) {
      const date = moment(data.selectedEndDate[0], 'DD MMM YYYY').format('YYYY-MM-DD');
      query = query.filter(({ CaseDate }) => CaseDate <= date);
    }

    if (data.hasOwnProperty('selectedRefs')) {
      query = query.filter(({ CoverRep }) => data.selectedRefs.indexOf(CoverRep) > -1);
    }

    if (data.hasOwnProperty('selectSurgeon')) {
      query = query.filter(({ SurgeonName }) => data.selectSurgeon.indexOf(SurgeonName) > -1);
    }

    if (data.hasOwnProperty('selectHospitals')) {
      query = query.filter(({ CustomerName }) => data.selectHospitals.indexOf(CustomerName) > -1);
    }

    if (data.hasOwnProperty('selectedTypes')) {
      query = query.filter(
        ({ CaseType }) => data.selectedTypes.indexOf(CaseType) > -1
      );
    }

    if (data.hasOwnProperty('ProcedureType')) {
      query = query.filter(
        ({ ProcedureType }) => data.ProcedureType.indexOf(ProcedureType) > -1
      );
    }

    if (data.hasOwnProperty('PatientID')) {
      const PatientID = data.PatientID.map((element) => element.trim());
      query = query.filter(
        (item) => ((item.PatientID !== null)
          && item.PatientID.indexOf(PatientID.toString().toUpperCase()) > -1
        )
      );
    }

    if (data.hasOwnProperty('Side')) {
      query = query.filter(
        ({ Side }) => data.Side.indexOf(Side) > -1
      );
    }

    if (data.hasOwnProperty('RepNotes')) {
      const RepNotes = data.RepNotes.toString();
      query = query.filter(
        (item) => ((item.RepNotes !== null)
          && item.RepNotes.indexOf(RepNotes) === -1
        )
      );
    }

    if (data.hasOwnProperty('Comments')) {
      const Comments = data.Comments.toString();
      query = query.filter(
        (item) => ((item.Comments !== null)
          && item.Comments.indexOf(Comments) === -1
        )
      );
    }

    if (data.hasOwnProperty('SurgeonNotes')) {
      const SurgeonNotes = data.SurgeonNotes.toString();
      query = query.filter(
        (item) => ((item.SurgeonNotes !== null)
          && item.SurgeonNotes.indexOf(SurgeonNotes) === -1
        )
      );
    }

    if (data.hasOwnProperty('keywordSearch')) {
      query = query.filter(
        (item) => ((item.RepNotes !== null) ? item.RepNotes.includes(data.keywordSearch[0]) : ''
          || (item.Comments !== null) ? item.Comments.includes(data.keywordSearch[0]) : ''
            || (item.PatientID !== null) ? item.PatientID.includes(data.keywordSearch[0]) : ''
              || (item.MRN !== null) ? item.MRN.includes(data.keywordSearch[0]) : ''
                || (item.Side !== null) ? item.Side.includes(data.keywordSearch[0]) : ''
                  || (item.Gender !== null) ? item.Gender.includes(data.keywordSearch[0]) : ''
        )
      );
    }
    return await query.toArray();
  } catch (e) {
    Bugsnag.notify(e);
  }
};

export const findUniqueCases = async (data, table) => {
  try {
    const caseRes = await db[table].toArray();
    const results = data.filter((result1) => !caseRes.some(
      (result2) => result1.RepCaseNo === result2.RepCaseNo
    ));
    return results === undefined ? [] : results;
  } catch (e) {
    Bugsnag.notify(e);
  }
};

export const setMissingDgrs = async (data) => {
  try {
    if (data.length > 0) {
      db.MissingDgrs.clear();
      // const user = await getUser();
      // const { selectedTeam: { timezone } } = user;
      for (const item of data) {
        // const dateTime = `${item.CaseDate} ${item.CaseTime}`;
        // const convertedDateTime = moment(moment.tz(
        //   dateTime, 'YYYY-MM-DD HH:mm', SERVER_TIMEZONE
        // )).tz(timezone).format('YYYY-MM-DD HH:mm');
        const date = moment(item.CaseDate).format('YYYY-MM-DD');
        const time = moment(item.CaseTime).format('HH:mm');
        item.CaseDate = date;
        item.CaseTime = time;
      }
      db.MissingDgrs.bulkAdd(data);
      return db;
    }
  } catch (e) {
    Bugsnag.notify(e);
  }
};

export const setMissingPos = async (data) => {
  try {
    if (data.length > 0) {
      db.MissingPos.clear();
      // const user = await getUser();
      // const { selectedTeam: { timezone } } = user;
      for (const item of data) {
        // const dateTime = `${item.CaseDate} ${item.CaseTime}`;
        // const convertedDateTime = moment(moment.tz(
        //   dateTime, 'YYYY-MM-DD HH:mm', SERVER_TIMEZONE
        // )).tz(timezone).format('YYYY-MM-DD HH:mm');
        const date = moment(item.CaseDate).format('YYYY-MM-DD');
        const time = moment(item.CaseTime).format('HH:mm');
        item.CaseDate = date;
        item.CaseTime = time;
      }
      db.MissingPos.bulkAdd(data);
      return db;
    }
  } catch (e) {
    Bugsnag.notify(e);
  }
};

export const setNotBilledCases = async (data) => {
  try {
    if (data.length > 0) {
      db.NotBilled.clear();
      // const user = await getUser();
      // const { selectedTeam: { timezone } } = user;
      for (const item of data) {
        // const dateTime = `${item.CaseDate} ${item.CaseTime}`;
        // const convertedDateTime = moment(moment.tz(
        //   dateTime, 'YYYY-MM-DD HH:mm', SERVER_TIMEZONE
        // )).tz(timezone).format('YYYY-MM-DD HH:mm');
        const date = moment(item.CaseDate).format('YYYY-MM-DD');
        const time = moment(item.CaseTime).format('HH:mm');
        item.CaseDate = date;
        item.CaseTime = time;
      }
      db.NotBilled.bulkAdd(data);
      return db;
    }
  } catch (e) {
    Bugsnag.notify(e);
  }
};

export const setBilledCases = async (data) => {
  try {
    if (data.length > 0) {
      db.Billed.clear();
      // const user = await getUser();
      // const { selectedTeam: { timezone } } = user;
      for (const item of data) {
        // const dateTime = `${item.CaseDate} ${item.CaseTime}`;
        // const convertedDateTime = moment(moment.tz(
        //   dateTime, 'YYYY-MM-DD HH:mm', SERVER_TIMEZONE
        // )).tz(timezone).format('YYYY-MM-DD HH:mm');
        const date = moment(item.CaseDate).format('YYYY-MM-DD');
        const time = moment(item.CaseTime).format('HH:mm');
        item.CaseDate = date;
        item.CaseTime = time;
      }
      db.Billed.bulkAdd(data);
      return db;
    }
  } catch (e) {
    Bugsnag.notify(e);
  }
};

export const deleteDb = () => {
  Dexie.delete('optimizeDb');
};

export const removePreferenceByPreferenceName = (preferenceName) => {
  try {
    db.Preferences.bulkDelete(preferenceName).then((response) => {
      if (response) {
        console.log('Preference deleted successfully.');
      } else {
        console.log('Something went wrong!');
      }
    });
  } catch (e) {
    Bugsnag.notify(e);
  }
};

export const getPreferenceByName = async (name) => await db.Preferences.where(
  { PreferenceName: String(name) }
).toArray();

export const updateSetQuantity = async (set) => {
  try {
    db.SetMaster.update({ id: set.id }, { Quantity: set.Quantity }).then((response) => {
      if (response) {
        console.log('Sets updated successfully.');
      } else {
        console.log('Sets not update! Please try again!');
      }
    });
  } catch (e) {
    Bugsnag.notify(e);
  }
};

// UPDATED Case details By PRIMARY Key
export const updateCaseByPrimaryId = (id, data) => {
  try {
    db.Cases.update({ id }, data).then((response) => {
      if (response) {
        console.log('Case updated successfully.');
      } else {
        console.log('Case not update! Please try again!');
      }
    });
  } catch (e) {
    Bugsnag.notify(e);
  }
};

export const updateTableCaseByPrimaryId = (id, data, tableName) => {
  try {
    db[tableName].update({ id }, data).then((response) => {
      if (response) {
        console.log('Case updated successfully.');
      } else {
        console.log('Case not update! Please try again!');
      }
    });
  } catch (e) {
    Bugsnag.notify(e);
  }
};

export const deletePreferenceByName = async (name) => db.Preferences.where(
  { PreferenceName: name }
).delete();

export const addUpdatedPreference = (data) => db.Preferences.add(data);

export const getProductDescriptionById = async (productId) => {
  try {
    const data = await db.ProductMaster.where({ ProductNo: productId }).first();
    return data === undefined ? '' : data.ProductDescription;
  } catch (err) {
    return '';
  }
};

export const getProductMaster = async () => await db.ProductMaster.toArray();

export const preferencesClear = async () => db.Preferences.clear();

export const addBulkPreferences = async (data) => db.Preferences.bulkAdd(data);

export const addRepReports = async (data) => {
  db.RepReports.clear();
  db.RepReports.bulkAdd(data);
};

export const getBillingFilterFieldList = async (tableName) => {
  const results = await db[tableName].toArray();
  return results;
};

export const getNotBilled = async () => await db.NotBilled.toArray();

export const getMissingDgrs = async () => await db.MissingDgrs.toArray();

export const getMissingPo = async () => await db.MissingPos.toArray();

export const getBilled = async () => await db.Billed.toArray();

export const getCaseScheduleIDFilter = async (cases) => await db.Cases
  .where('CaseScheduleID')
  .anyOf(cases)
  .reverse()
  .sortBy('CaseDate');

export const updateCaseByCaseScheduleID = (id, data) => {
  try {
    db.Cases.update({ CaseScheduleID: id }, data).then((response) => {
      if (response) {
        console.log('Case updated successfully.');
      } else {
        console.log('Case not update! Please try again!');
      }
    });
  } catch (e) {
    Bugsnag.notify(e);
  }
};

export const bulkCaseDelete = (preferenceName) => {
  try {
    db.Cases.where({ CaseScheduleID: preferenceName }).delete()
      .then((response) => {
        if (response) {
          console.log('Cases deleted successfully.');
        } else {
          console.log('Something went wrong!');
        }
      });
  } catch (e) {
    Bugsnag.notify(e);
  }
};

export const bulkCaseUpdate = async (cases, startDate, endDate) => {
  try {
    const data = await db.Cases.where('CaseDate').between(startDate, endDate, true, true).toArray();
    const result = data.filter(
      (o1) => !cases.some((o2) => o1.CaseScheduleID === o2.CaseScheduleID)
    );

    await Promise.all(result.map(async (currentCase) => {
      await db.Cases.where({ id: currentCase.id }).delete();
    }));

    await Promise.all(cases.map(async (currentCase) => {
      // const user = getUser();
      // const { selectedTeam: { timezone } } = user;
      // const updatedCase = formatCase(currentCase, timezone);
      const updatedCase = formatCase(currentCase);
      await db.Cases.where({ CaseScheduleID: currentCase.CaseScheduleID }).modify(updatedCase);
    }));
  } catch (e) {
    Bugsnag.notify(e);
  }
};

export const setInventoryData = async (data) => {
  try {
    // ADD INVENTORY
    if (data.length > 0) {
      try {
        const inventoryRes = await db.Inventory.toArray();
        if (data.length > inventoryRes.length) {
          db.Inventory.clear();
          db.Inventory.bulkAdd(data);
        }
      } catch (err) {
        console.log('err', err);
      }
    }
  } catch (e) {
    Bugsnag.notify(e);
  }
};

// ADD NEW INSERTED INVENTORY RESPONSE
export const insertScanInventory = (data) => {
  try {
    db.InventoryScans.add(data).then((response) => {
      if (response) {
        console.log('Inventory inserted successfully.');
      } else {
        console.log('Inventory not insert! Please try again!');
      }
    });
  } catch (e) {
    Bugsnag.notify(e);
  }
};

export const getAccountName = async () => await db.Inventory.toArray();

export const getInventoryByAccountName = async (
  accountName
) => await db.InventoryScans.where({ AccountName: accountName }).toArray();

export const getInventoryProductsByAccountName = async (
  accountName
) => await db.Inventory.where({ AccountName: accountName }).toArray();

export const getSingleScanSessionData = async (name, id) => await db.InventoryScans.where(
  { SessionName: name, SessionID: id }
).toArray();

export const getInventoryBySessionID = async (
  SessionID
) => await db.InventoryScans.where({ SessionID }).toArray();

export const deleteByPrimaryKey = async (id) => await db.InventoryScans.where(
  { inventoryId: id }
).delete();

export const updateInventoryByLocalInventoryId = (id, data) => {
  try {
    db.InventoryScans.update({ inventoryId: id }, data).then((response) => {
      if (response) {
        console.log('Case updated successfully.');
      } else {
        console.log('Case not update! Please try again!');
      }
    });
  } catch (e) {
    Bugsnag.notify(e);
  }
};

export const updateInventoryByInventoryId = (id, data) => {
  try {
    db.InventoryScans.update({ inventoryId: id }, data).then((response) => {
      if (response) {
        console.log('Case updated successfully.');
      } else {
        console.log('Case not update! Please try again!');
      }
    });
  } catch (e) {
    Bugsnag.notify(e);
  }
};

export const getInventoryByID = async (id) => {
  try {
    const results = await db.InventoryScans.get({ ID: id });
    return results === undefined ? {} : results;
  } catch (e) {
    Bugsnag.notify(e);
  }
};

export const getInventory = async () => await db.InventoryScans.toArray();

export const getConsignmentByProductNoAndLotNo = async (productNo, lotNo) => await db.Inventory
  .where({ ProductNo: productNo, LotNo: lotNo, InventoryType: 'CONSIGN' }).first();

export const getConsignmentByProductNoToArray = async (productNo) => await db.Inventory
  .where({ ProductNo: productNo, InventoryType: 'CONSIGN' }).toArray();

export const getConsignmentByProductNo = async (productNo) => await db.Inventory
  .where({ ProductNo: productNo, InventoryType: 'CONSIGN' }).first();

// export const getInventoryScanProductByAccNameAndType = async (accName) => await db
//   .InventoryScans
//   .where('[AccountName+ProductEnterType]')
//   .anyOf([accName, 'SCAN'], [accName, 'MANUAL'], [accName, 'EXTDEVICE'])
//   .toArray();
export const getInventoryScanProductByAccNameAndType = async (
  accName
) => await db.InventoryScans
  .where({ AccountName: accName, ProductEnterType: 'SCAN' }).toArray();

export const getInventoryScanProductManualByAccNameAndType = async (
  accName
) => await db.InventoryScans
  .where({ AccountName: accName, ProductEnterType: 'MANUAL' }).toArray();

export const getInventoryScanProductExtDevByAccNameAndType = async (
  accName
) => await db.InventoryScans
  .where({ AccountName: accName, ProductEnterType: 'EXTDEVICE' }).toArray();

export const getInventoryScanProductByType = async () => await db.InventoryScans
  .where('ProductEnterType').anyOf(['SCAN', 'MANUAL', 'EXTDEVICE']).toArray();

export const getVhnPpcValue = async (hospitalName) => db.Hospitals
  .where({ CustomerName: hospitalName }).first();

// ADD NEW INSERTED Compliance_App RESPONSE
export const insertComplianceApp = (data) => {
  try {
    db.ComplianceApp.add(data).then((response) => {
      if (response) {
        console.log('Compliance_App inserted successfully.');
      } else {
        console.log('Compliance_App not insert! Please try again!');
      }
    });
  } catch (e) {
    Bugsnag.notify(e);
  }
};

export const getUnSubmittedScanSessions = async () => await db.InventoryScans.where(
  { Submitted: 0 }
).toArray();

// Delete unSubmitted scan sessions
export const deleteUnSubmittedScanSessions = async () => {
  await db.InventoryScans.where({ Submitted: 0 }).delete();
};

export const deleteAllCases = async () => {
  await db.Cases.where({ Sync: 0 }).delete();
};

export const getDersTeamsByTeamName = async (teamName) => await db.Teams.where(
  { TeamName: teamName }
).first();

export const deleteInventoryData = async () => {
  await db.Inventory.clear();
};

export const deleteInventoryScansData = async () => {
  await db.InventoryScans.clear();
};

export const setDersData = async (data) => {
  try {
    if (data.length > 0) {
      db.DERs.clear();
      db.DERs.bulkAdd(data);
      return db;
    }
  } catch (e) {
    Bugsnag.notify(e);
  }
};

export const getDersByDersNo = async (dersNo) => {
  try {
    const data = await db.DERs.where({ DERNo: dersNo }).first();
    return data === undefined ? {} : data;
  } catch (err) {
    return {};
  }
};

export const updateDersById = async (id, data) => {
  try {
    db.DERs.update({ id }, data).then((response) => {
      if (response) {
        console.log('DERs updated successfully.');
      } else {
        console.log('DERs not update! Please try again!');
      }
    });
  } catch (e) {
    Bugsnag.notify(e);
  }
};

// ADD NEW INSERTED DERs RESPONSE
export const insertDers = (data) => {
  try {
    db.DERs.add(data).then((response) => {
      if (response) {
        console.log('Ders inserted successfully.');
      } else {
        console.log('Ders not insert! Please try again!');
      }
    });
  } catch (e) {
    Bugsnag.notify(e);
  }
};

export const getAllDers = async () => await db.DERs.toArray();

export const getAllSurgeonNotes = async () => await db.SurgeonNotes.toArray();

export const getSurgeonNotesByName = async (name) => await db.SurgeonNotes.where(
  { SurgeonName: name }
).toArray();

export const surgeonNotesClear = async () => db.SurgeonNotes.clear();

export const addBulkSurgeonNotes = async (data) => db.SurgeonNotes.bulkAdd(data);

export const updateSurgeonNotes = async (set) => {
  try {
    db.SurgeonNotes.update({ SurgeonName: set.name }, { notes: set.notes }).then((response) => {
      if (response) {
        console.log('SurgeonNotes updated successfully.');
      } else {
        console.log('SurgeonNotes not update! Please try again!');
      }
    });
  } catch (e) {
    Bugsnag.notify(e);
  }
};

export const deleteSurgeonNotesByName = async (id) => {
  try {
    db.SurgeonNotes.delete(Number(id)).then((response) => {
      if (response) {
        console.log('SurgeonNotes deleted successfully.');
      } else {
        console.log('Something went wrong!');
      }
    });
  } catch (e) {
    Bugsnag.notify(e);
  }
};

export const getDocuments = async () => await db.Documents.toArray();

export const addDocuments = async (data) => {
  db.Documents.clear();
  db.Documents.bulkAdd(data);
};

export const getProductType = async (value) => {
  try {
    let data = await db.TypeOptions.where({ OptionType: 'ProductType' }).toArray();

    console.log('value for:', value);
    // console.log('value for:', typeof value);

    if (typeof value !== 'undefined' && value !== null && value !== '') {
      if (typeof value.productNo !== 'undefined' && value.productNo !== '') {
        const searchValue = value.productNo.toString(); // Convert to string

        data = data.filter(
          (item) => (
            item.OptionNo.includes(searchValue)
            || item.OptionName.toUpperCase().includes(searchValue.toUpperCase())
          )
        );
      }
    }

    return data;
  } catch (e) {
    Bugsnag.notify(e);
  }
};
